export default __webpack_public_path__ + "3034b1fd5bbd4a54ba6d364696a445b1.webp";